import { Button, Card, CardContent, Grid, alpha, darken, lighten, useTheme } from '@mui/material';
import Styles from '../theme/commonCss/Styles';
import Modal from './Modal';
import { get } from 'lodash';
import { useOutletContext } from 'react-router-dom';

const FormModal = ({
  children,
  title,
  isOpen,
  handleSubmit = () => { },
  handleClose = () => { },
  handleNext,
  activeStep,
  isStepperForm,
  handleBack,
  handleReset,
  customStyles,
  disableSave,
  showclose,
  containerStyles,
  hideButtons,
  customButtons,
  readOnly,
  noclosepadding,
  disableOverflow
}: any) => {
  const themeData: any = useTheme();
  const themeMode: any = get(useOutletContext(), 'themeMode', {})
  return (
    <Modal
      title={title}
      open={isOpen}
      handleClose={handleClose}
      dialogContentStyles={Styles.masterContainer}
      customStyles={{
        ...customStyles,
        maxHeight: '80vh'
      }}

      containerStyles={containerStyles}
    >

      <Card sx={{
        ...Styles.card, overflow: disableOverflow ? 'hidden !important' : 'scroll', backgroundColor: (themeMode.isLightBG) ? lighten(themeData.palette.background.default, 0.9) : lighten(themeData.palette.background.default, 0.05),
        // '::-webkit-scrollbar': {
        //   width: '8px',
        //   height: '8px'
        // },

        // '::-webkit-scrollbar-thumb:hover': {
        //   background: '#8c9aba'
        // },

        // '::-webkit-scrollbar-thumb': {
        //   background: '#A6B5D8',
        //   borderRadius: '16px',
        //   borderBottomWidth: '100px'
        // },
        // '& ::-webkit-scrollbar-track': {
        //   margin: '12px'
        // }
      }}>
        <CardContent component='form' onSubmit={handleSubmit} sx={{ ...Styles.cardContent, ...containerStyles, backgroundColor: 'transparent' }}>
          {children}
          {!hideButtons &&
            <Grid container sx={{ marginTop: '32px' }}>
              {customButtons ? <Grid item xs={12} textAlign="center">
                {customButtons}
              </Grid>
                : showclose ? <Grid item xs={12} textAlign={'center'} sx={{ paddingBottom: noclosepadding ? '0' : '24px' }}>
                  <Button variant='outlined' sx={{ mr: 3, width: '100px', height: '42px' }} onClick={handleClose}>
                    Close
                  </Button>
                </Grid> : <Grid xs={12} textAlign={'center'} item={true}>
                  {isStepperForm ? (
                    activeStep && activeStep == 2 ? (
                      <>
                        <Button variant='outlined' sx={{ mr: 3, width: '100px', height: '42px' }} onClick={handleBack}>
                          Back
                        </Button>
                        <Button variant='contained' type='submit' sx={{ width: '100px' }}>
                          Save
                        </Button>
                      </>
                    ) : (
                      <>
                        <Button variant='outlined' sx={{ mr: 3, width: '100px', height: '42px' }} onClick={handleBack}>
                          Back
                        </Button>
                        <Button variant='contained' sx={{ width: '100px' }} onClick={handleNext}>
                          Next
                        </Button>
                      </>
                    )
                  ) : (
                    <>
                      <Button variant='outlined' sx={{ mr: 3, width: '100px', height: '42px' }} onClick={handleClose}>
                        {readOnly ? 'Close' : 'Cancel'}
                      </Button>
                      {!readOnly && <Button variant='contained' type='submit' sx={{ width: '100px' }} disabled={disableSave}>
                        Save
                      </Button>}
                    </>
                  )}
                </Grid>}
            </Grid>
          }
        </CardContent>
      </Card >
    </Modal >
  );
};

export default FormModal;
